export default __webpack_public_path__ + "static/media/fondo.eeab0c4f.jpg";